import { myPageAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';

export default {
  async FETCH_LIST({ commit, getters }, { action }) {
    const condition = getters['getCondition'];
    const { totalPage } = getters['getPageInfo'];

    if (condition.page > totalPage) return;

    condition.action = action;
    const { status, data } = await ServiceExec.get(
      myPageAPI.point_list,
      condition
    );

    if (status === ServiceExec.status.OK) {
      const { list, pageInfo } = data;
      commit('setPage', condition.page + 1);
      commit('setList', list);
      commit('setPageInfo', pageInfo);
    }
  },

  async FETCH_TOTAL_POINT({ commit }, userNo) {
    const { data } = await ServiceExec.get(myPageAPI.point_total(userNo));
    commit('setTotalPoint', data);
    return data;
  }
};
